module.exports = __webpack_public_path__ + "static/media/edit-file.1ef130fc.svg";